<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
            <calendar>
            </calendar> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import calendar from './todo-calendar'
    export default {
        components: {
            calendar
        }
    }
    </script>
      <style lang='scss'>

            .bg-breadcrum{
                background:#fff !important;
            }
            .link-default{
                color: #666!important;
            }
        
            .fc-past{
            background-color: #fff;
            color: #555;
            }
        </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-calendar/base-calendar.vue